import AutoloadViews from '@galaxy/modules/Core/resources/js/AutoloadViews.js';

// Include all block.js / block.vue's, except form admin. Include from this module as well as from the app.
AutoloadViews.load('canvas::canvas.block', require.context('./../components/canvas/blocks/', true, /^((?!admin).)*\/block.(js|vue)$/));
AutoloadViews.load('canvas.block', require.context('@app/resources/components/canvas/', true, /^((?!admin).)*\/block.(js|vue)$/));

AutoloadViews.load('canvas::editor', require.context('./editor/admin/', true, /\.(js|vue)$/));

// Responsive tables: inject thead labels as data-label on td for mobile card layout.
// Only applies to tables inside canvas block utils that have a <thead>.
addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[class*="canvas::canvas-blocks-utils-"] table').forEach(table => {
        const thead = table.querySelector('thead');
        if (!thead) return;

        const headers = [...thead.querySelectorAll('th')].map(th => th.textContent.trim());

        table.querySelectorAll('tbody tr').forEach(tr => {
            tr.querySelectorAll('td').forEach((td, i) => {
                if (headers[i]) {
                    td.dataset.label = headers[i];
                }
            });
        });

        table.dataset.responsive = '';
    });
});
